import { CircleAlert, CircleCheck, Info, TriangleAlert, Wrench } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import type { TipoStatus } from './SeloStatus';

const ICONES = {
  sucesso: CircleCheck,
  alerta: TriangleAlert,
  perigo: CircleAlert,
  info: Info,
  neutro: Info,
  desenvolvimento: Wrench,
} satisfies Record<TipoStatus, unknown>;

const CORES: Record<TipoStatus, string> = {
  sucesso: 'border-sucesso/40 bg-sucesso-fundo text-sucesso',
  alerta: 'border-alerta/40 bg-alerta-fundo text-alerta',
  perigo: 'border-perigo/40 bg-perigo-fundo text-perigo',
  info: 'border-info/40 bg-info-fundo text-info',
  neutro: 'border-borda bg-neutro-fundo text-neutro',
  desenvolvimento: 'border-desenvolvimento/40 bg-desenvolvimento-fundo text-desenvolvimento',
};

/**
 * Mensagem em destaque. Erros usam role="alert" (o leitor de tela anuncia na hora);
 * os demais usam role="status" (anunciado sem interromper).
 */
export function Alerta({
  tipo = 'info',
  titulo,
  children,
  className,
}: {
  tipo?: TipoStatus;
  titulo?: string;
  children?: ReactNode;
  className?: string;
}) {
  const Icone = ICONES[tipo];
  return (
    <div
      role={tipo === 'perigo' ? 'alert' : 'status'}
      className={cn('flex gap-3 rounded-lg border p-4', CORES[tipo], className)}
    >
      <Icone className="mt-0.5 size-5 shrink-0" aria-hidden="true" />
      <div className="text-sm">
        {titulo && <p className="font-semibold">{titulo}</p>}
        {children && <div className={cn(titulo && 'mt-1', 'text-texto')}>{children}</div>}
      </div>
    </div>
  );
}
